import React from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { dictionary } from "../../../utils/core/dictionary";

export interface DialogProps {
  open: boolean;
  title: string;
  content: string;
  handleClose: (e: any) => void;
  handleConfirm: (e: any) => void;
  hideButtons?: boolean;
}

export function AlertDialog({
  open,
  title,
  content,
  handleClose,
  handleConfirm,
  hideButtons,
}: DialogProps) {
  return (
    <Dialog open={open} onClose={handleClose} maxWidth={"xs"} fullWidth>
      <Box px={2} py={1}>
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
          <Box py={1}>{content}</Box>
        </DialogContent>
        {!hideButtons && (
          <DialogActions>
            <Button onClick={handleClose} color="primary" variant={"outlined"}>
              {dictionary.CLOSE}
            </Button>
            <Button
              onClick={handleConfirm}
              color="primary"
              variant={"contained"}
            >
              {dictionary.CONFIRM}
            </Button>
          </DialogActions>
        )}
      </Box>
    </Dialog>
  );
}
